import React, { Component } from 'react'
import { Alert } from 'loyal-react'
import PropTypes from 'prop-types'
import ReactPlaceholder from 'react-placeholder'
import TwoStepVerificationPlaceholder from './TwoStepVerificationPlaceholder'
import { PhoneEmpty } from './PhoneEmpty/index'
import { HasPhone } from './HasPhone/index'
import { SendDocuments } from './SendDocuments/index'
import { DocumentAnalysis } from './DocumentAnalysis/index'

class TwoStepVerification extends Component {
  state = {
    hasPhone: false,
    sendDocuments: false,
    documentAnalysis: false,
    showAlertBox: false,
    isError: false,
    isCountdown: false,
    title: '',
    description: ''
  }

  countdown (element, minutes, seconds) {
    var time = minutes * 60 + seconds
    var interval = setInterval(function () {
      var el = document.getElementById(element)
      if (time <= 0) {
        var text = 'O código gerado expira em 00:00'
        el.innerHTML = text
        clearInterval(interval)
        return
      }

      var minutes = Math.floor(time / 60)
      if (minutes < 10) minutes = '0' + minutes

      var seconds = time % 60
      if (seconds < 10) seconds = '0' + seconds

      text = 'O código gerado expira em ' + minutes + ':' + seconds

      el.innerHTML = text

      time--
    }, 1000)
  }

  faqTwoStep () {
    window.location.href = '/faq-two-step'
  }

  render () {
    return (
      <ReactPlaceholder
        ready={!this.props.isLoading}
        customPlaceholder={<TwoStepVerificationPlaceholder />}
      >
        <div className='container mt-5 mt-md-0 px-0 px-md-1 pt-1 pt-md-0 py-md-4'>
          <Alert
            isError={this.state.isError}
            title={this.state.title}
            description={this.state.description}
            className={`pt-3 pt-md-0 pb-2 px-2 px-md-0 ${this.state.showAlertBox && !this.state.isCountdown ? '' : 'd-none'}`}
            onClose={() => {}}
          />
          {this.state.showAlertBox && this.state.isCountdown
            ? <div className='col-12 px-0 mr-auto ml-auto confirmation-alert pt-3 pt-md-0 pb-2 px-2 px-md-0'>
              <div className={`bg-white radius border-brand-1 border-left-lg border-color-brand-1 py-3 px-3`}>
                <div className='row align-items-center h-100'>
                  <div className='col-auto'>
                    <i className={`icon icon_clock color-brand-1`} />
                  </div>
                  <div className='col col-md-10 mr-auto'>
                    <h2 id='countDownText' className={`color-brand-1 txt-circular-book txt-body-lg`} aria-hidden='true'>
                      {
                        this.state.isCountdown
                          ? this.countdown('countDownText', 0, 120)
                          : ''
                      }
                    </h2>
                  </div>
                  <div className='col-auto d-none' />
                </div>
              </div>
            </div>
            : ''
          }
          <div className={`row mx-0 ${this.state.sendDocuments ? 'd-none' : ''}`}>
            <div className='col-12 border-color-ui-3 bg-white border radius'>
              <div className='row px-1 py-2 border-bottom border-color-ui-3'>
                <div className='col mr-auto'>
                  <h3 className='txt-title txt-circular-book txt-initial color-ui-black mr-auto'>
                    Verificação em 2 etapas
                  </h3>
                </div>
                <div
                  className='col-auto mr-auto color-brand-1 txt-font-body txt-body-sm d-flex align-items-center pointer'
                  onClick={() => this.faqTwoStep()}
                >
                  <i className='icon icon_question txt-body-sm color-brand-1 mr-md-1' />
                  <span className='d-none d-md-block'>Dúvidas frequentes</span>
                </div>
              </div>
              <div className={`row px-2 py-2 border-bottom border-color-ui-3 ${!this.state.hasPhone || this.state.documentAnalysis ? 'd-none' : ''}`}>
                <HasPhone {...this.props} />
              </div>
              <div className={`row px-2 py-2 border-bottom border-color-ui-3 ${this.state.hasPhone || this.state.documentAnalysis ? 'd-none' : ''}`}>
                <PhoneEmpty {...this.props} />
              </div>
              <div className={`row px-2 py-2 border-bottom border-color-ui-3 ${this.state.documentAnalysis ? '' : 'd-none'}`}>
                <DocumentAnalysis {...this.props} />
              </div>
            </div>
          </div>
          <div className={`row mx-0 ${this.state.sendDocuments ? '' : 'd-none'}`}>
            <div className='col-12 border-color-ui-3 bg-white border radius'>
              <div className='row px-1 py-2 border-bottom border-color-ui-3'>
                <div className='col mr-auto'>
                  <h3 className='txt-title txt-circular-book txt-initial color-ui-black mr-auto'>
                    Envio de documentos
                  </h3>
                </div>
                <div
                  className='col-auto mr-auto color-brand-1 txt-font-body txt-body-sm d-flex align-items-center pointer'
                  onClick={() => this.faqTwoStep()}
                >
                  <i className='icon icon_question txt-body-sm color-brand-1 mr-md-1' />
                  <span className='d-none d-md-block'>Dúvidas frequentes</span>
                </div>
              </div>
              <SendDocuments />
            </div>
          </div>
        </div>
      </ReactPlaceholder>
    )
  }
}

TwoStepVerification.propTypes = {
  isLoading: PropTypes.bool,
  hasPhone: PropTypes.bool,
  sendDocuments: PropTypes.bool,
  showAlertBox: PropTypes.bool,
  isError: PropTypes.bool,
  isCountdown: PropTypes.bool,
  title: PropTypes.string,
  description: PropTypes.string
}

export default TwoStepVerification



// WEBPACK FOOTER //
// ./src/Participant/TwoStepVerification/TwoStepVerification.js